import util from 'libs/util';

class TimingManager {
  constructor(options = {}) {
    this.options = options;
    this._isTiming = false;
    this._list = options.taskList || [];
    this.len = this._list.length;
    this._timeTypeList = options.timeTypeList || [];
    if (this._timeTypeList.length > 0) {
      this._delayMode = this._timeTypeList[0];
      this.setTimeMode(this._delayMode)
    }
    this.modeType = options.modeType;
    this._curIndex = this.findStartIndex(options.initId);
  }
  setList(list) {
    this._list = list;
  }
  findStartIndex(id) {
    let list = this._list;
    let index = list.findIndex((n) => {
      return n == id;
    });
    return index || 0;
  }
  setIndexById(id) {
    let index = this.findStartIndex(id);
    this._curIndex = index
  }
  getDisableOptsById(id) {
    let index = this.findStartIndex(id);
    return this.getDisableOpts(index)
  }
  toggle() {
    this._isTiming = !this._isTiming;
  }
  start(index, isCall) {
    this._isTiming = true;
    if (index >= this._list.length) {
      index = 0;
    }
    if (this._list && this._list.length > 0) {
      if (isCall) {
        if (typeof index != 'undefined') {
          this._curIndex = index;
        }
        this.callTask()
      }
      this.options.onStart && this.options.onStart({ curIndex: this._curIndex });
    }
  }
  stop(reset) {
    this._isTiming = false;
    if (reset) {
      this._delayMode = this._timeTypeList[0];
    }
    this.options.onStop && this.options.onStop()
  }
  pause() {
    this._isTiming = false;
  }
  setMode(mode) {
    this.modeType = mode;
    this.options.onPlayModeChange && this.options.onPlayModeChange(mode);
  }
  setTimeMode(mode, autoPlay) {
    this.timer && clearInterval(this.timer);
    this._delayMode = mode;
    this._isTiming = autoPlay;
    let callTime = (ss) => {
      let sf = util.date.secondsTo(ss);
      this._sf = sf;
      this.options.onTimingUpdate && this.options.onTimingUpdate(sf, ss)
    }
    if (mode.id != -1) {
      let s = mode.value;
      this.timer = setInterval(() => {
        if (this._isTiming) {
          if (s > 0) {
            s--;
          } else {
            clearInterval(this.timer);
            this.stop(true);
          }
          callTime(s)
        }
      }, 1000);
      callTime(s)
      if (this._isTiming) {
        this.start(false);
      }
    } else {
      callTime(0);
      this.timer && clearInterval(this.timer);
      this._delayMode = this._timeTypeList[0];
    }
    this.options.onTimeModeChange && this.options.onTimeModeChange(this._delayMode);
  }
  getMode() {
    return this._delayMode;
  }
  getState() {
    let p = {
      timeMode: this._delayMode,
      loopMode: this.modeType
    }
    if (this._delayMode.id != -1) {
      p.sf = this._sf;
    }
    return p;
  }
  callTask() {
    let options = this.options;
    let index = this._curIndex;
    let disableOpts = this.getDisableOpts(index)
    if (index >= 0 && index < this.len) {
      this.options.onCall && this.options.onCall(this._list[index], index, disableOpts);
    }
  }
  getDisableOpts(index) {
    return {
      preDisabled: index < 1 ? true : false,
      nextDisabled: index < this.len - 1 ? false : true
    }
  }
  pre() {
    let len = this._list.length;
    if (this._curIndex > 0) {
      this._curIndex--;
      this.callTask(this._curIndex)
    }
  }
  next() {
    let len = this._list.length;
    if (this._curIndex < len - 1) {
      this._curIndex++;
      this.callTask(this._curIndex)
    }
  }
  callIndex(index) {
    this._curIndex = index;
    this.callTask(index)
  }
  callNext() {
    let len = this._list.length;
    if (this.modeType == 1) {
      this.stop();
    }
    if (this.modeType == 2 || this.modeType == 3) {
      if (this.modeType == 2) { // 单个循环
        this.callTask(this._curIndex);
      } else {
        if (this._curIndex < len - 1) {
          this._curIndex++;
          this.callTask(this._curIndex)
        } else {
          this._curIndex = 0;
          this.callTask(this._curIndex)
        }
      }
    }
  }
  destory() {
    this.stop();
    console.log('destory');
    clearInterval(this.timer);
  }
}

export default TimingManager